import React from 'react';
import classNames from 'classnames';
import './Card.css';

export function Card({ 
  children, 
  padding = 'md', 
  hoverable = false, 
  bordered = true,
  className = '',
  ...props 
}) {
  const cardClasses = classNames(
    'agrisense-card',
    `agrisense-card--padding-${padding}`,
    {
      'agrisense-card--hoverable': hoverable,
      'agrisense-card--bordered': bordered,
    },
    className
  );

  return (
    <div className={cardClasses} {...props}>
      {children}
    </div>
  );
}